import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';

export const BiddableListingDetailsDataItemListWrapper = styled(MUIBox)({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '4px',
});

export const BiddableListingDescriptionWrapper = styled(MUIBox)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const BiddableListingDetailsHeadingWrapper = styled(MUIBox)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  width: '100%',
});

export const BiddableListingDetailsWrapper = styled(MUIBox)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '24px',
});
